import {useTranslation} from '@app/hooks/use-translation';
import type {FunctionComponent} from 'react';
import {LandingButtonLink} from '@app/components/landing-btn-link';
import {Image} from '@app/components/Image';
import {useLocation} from '@app/hooks/use-location';
import {LandingHeading, LandingParagraph} from '@tempo/landing';
import {LandingIllustrationSection} from '@app/components/layout/LandingIllustrationSection';

export const OfflineHero: FunctionComponent = () => {
	const {t} = useTranslation();
	const {getDeezerUrl} = useLocation();

	return (
		<LandingIllustrationSection
			description={
				<>
					<LandingHeading as="h1">
						{t(
							'offlinelandingpage_title_noconnectionnoproblem_standalone-web',
							{ns: 'offline'},
						)}
					</LandingHeading>
					<LandingParagraph>
						{t('offlinelandingpage_text_noconnectionnoproblem_standalone-web', {
							ns: 'offline',
						})}
					</LandingParagraph>
					<LandingButtonLink
						tracking={{eventaction: 'discover-offers'}}
						href={getDeezerUrl('/offers')}
						target="_blank"
						isMain
					>
						{t('generic_action_seeallplans_standalone-web', {ns: 'common'})}
					</LandingButtonLink>
				</>
			}
			image={
				<Image
					objectFit={{base: 'cover', md: 'contain'}}
					minH="150px"
					alt={t(
						'featureslandingpage_title_singalongwithlyrics_standalone-web',
						{ns: 'features'},
					)}
					src="76c990bc6890dd5b3f0a1791c3a6506a.png"
					aspectRatio="2880/840"
					quality={95}
					priority
				/>
			}
		/>
	);
};
